export const config = {
  validation: {
    minlength: 1,
  },
  loadCommentFromMytimes: false,
  commentType: 'comments',
  loadonscroll: true,
  sendCommentLiveEmail: true,
  loginRequiredForRating: true,
  nonloggedinComment: true,
  disabledirectcomment: false,
  maxchar: 3000,
  maxCommentWrapLength: 500,
  maxResponseCount: 3,
  hideResponses: false,
  share_url: '/share.cms',
  verify_comment_url: '/json/cmtverified.cms',
  messages: {
    name_required: 'Please enter your name.',
    location_required: 'Please enter your location.',
    captcha_required: 'Please enter captcha value.',
    name_toolong: 'Name cannot be longer than 30 chars.',
    name_not_string: 'Name can only contain alphabets.',
    location_toolong: 'Location cannot be longer than 30 chars.',
    location_not_string: 'Location can only contain alphabets.',
    captcha_toolong: 'Captcha cannot be longer than 4 chars.',
    captcha_number_only: 'Captcha value can only be a number.',
    email_required: 'Please enter your email address.',
    email_invalid: 'Please enter a valid email address.',
    captcha_invalid: 'Please enter a valid captcha value.',
    minlength: "You can't post this comment as the length it is too short. ",
    blank: "You can't post this comment as it is blank.",
    maxlength: 'You have entered more than 3000 characters.',
    popup_blocked: 'Popup is blocked.',
    has_url: "You can't post this comment as it contains URL.",
    duplicate:
      "You can't post this comment as it is identical to the previous one.",
    abusive:
      "You can't post this comment as it contains inappropriate content.",
    self_agree: "You can't Agree with your own comment",
    self_disagree: "You can't Disagree with your own comment",
    self_recommend: "You can't Recommend your own comment",
    self_offensive: "You can't mark your own comment as Offensive",
    already_agree: 'You have already Agreed with this comment',
    already_disagree: 'You have already Disagreed with this comment',
    already_recommended: 'You have already Recommended this comment',
    already_offensive: 'You have already marked this comment Offensive',
    cant_agree_disagree: "You can't Agree and Disagree with the same comment",
    cant_agree_offensive: "You can't Agree and mark the same comment Offensive",
    cant_disagree_recommend:
      "You can't Disagree and Recommend the same comment",
    cant_recommend_offensive:
      "You can't Recommend and mark the same comment Offensive",
    permission_facebook:
      "You can't post to facebook. Post permission is required.",
    offensive_reason: 'Please select a reason.',
    offensive_reason_text: 'Please enter a reason.',
    offensive_reason_text_limit: 'Please enter less than 200 chars.',
  },
};

export const RATE_TYPE = {
  AGREED: 'AGREED',
  DISAGREED: 'DISAGREED',
  OFFENSIVE: 'OFFENSIVE',
};

export function loadCommentsApi() {
  return {
    endpoint: `/commentsdata.cms`,
    params: {
      msid: null,
      curpg: 1,
      commenttype: 'agree',
      pcode: 'TOI',
      appkey: 'TOI',
      sortcriteria: 'AgreeCount',
      order: 'desc',
      size: 25,
      lastdeenid: null,
      after: 'true',
      withReward: 'true',
      medium: 'WEB',
      comment_block_count: 25,
      pagenum: 1,
    },
  };
}

export function getCommentsValidateApi() {
  return {
    endpoint: `/validatecomment.cms`,
    params: {
      fromname: null,
      fromaddress: null,
      userid: null,
      location: null,
      imageurl: null,
      loggedstatus: null,
      message: null,
      roaltdetails: null,
      ArticleID: null,
      msid: null,
      parentid: null,
      rootid: null,
      medium: 'WEB',
    },
  };
}

export function getCommentsPostApi() {
  return {
    endpoint: `/postro2.cms`,
    params: {
      fromname: null,
      fromaddress: null,
      userid: null,
      location: null,
      imageurl: null,
      loggedstatus: null,
      message: null,
      roaltdetails: null,
      ArticleID: null,
      msid: null,
      parentid: null,
      rootid: null,
      medium: 'WEB',
    },
  };
}

export function getSortTypeData() {
  const upvoted = {
    label: 'upvoted',
    queryParams: {
      sortcriteria: 'AgreeCount',
      order: 'desc',
      commenttype: 'agree',
      size: 3,
      comment_block_count: 3,
    },
  };

  const newest = {
    label: 'newest',
    queryParams: {
      sortcriteria: 'CreationDate',
      order: 'asc',
      ordertype: 'asc',
      size: 3,
      comment_block_count: 3,
    },
  };

  const oldest = {
    label: 'oldest',
    queryParams: {
      sortcriteria: 'CreationDate',
      order: 'desc',
      ordertype: 'asc',
      size: 3,
      comment_block_count: 3,
    },
  };

  const discussed = {
    label: 'discussed',
    queryParams: {
      sortcriteria: 'discussed',
      order: 'desc',
      commenttype: 'mostdiscussed',
      size: 3,
      comment_block_count: 3,
    },
  };

  const downVoted = {
    label: 'downVoted',
    queryParams: {
      sortcriteria: 'DisagreeCount',
      order: 'desc',
      commenttype: 'disagree',
      size: 3,
      comment_block_count: 3,
    },
  };

  return [upvoted, newest, oldest, discussed, downVoted];
}

export function getFlagApiData() {
  return {
    endpoint: '/offensive/mark',
    params: {
      ofusername: null,
      ofreason: 'NONE',
      ofcommenteroid: null,
      ofcommenthostid: 83,
      ofcommentchannelid: '-2128958273',
      ofcommentid: null,
      ofuserisloggedin: null,
      ofuserssoid: null,
      ofuseremail: null,
    },
  };
}
